import React from "react";

const EmployerDashboard = () => {
  return (
    <div>
      <h2>Employer Dashboard</h2>
      <p>You are logged in.</p>
    </div>
  );
};

export default EmployerDashboard;